import { Link } from "@thrivetribe/mvf.ui.organisms.footer";

export const footerLinks: Link[] = [
  { url: "https://manvfat.com/privacy-policy", text: "Privacy Policy", target: "_blank" },
  { url: "https://manvfat.com/man-v-fat-terms-and-conditions", text: "Terms and Conditions", target: "_blank" },
  { url: "mailto:football@manvfat.com", text: "Contact Us" },
  { url: "https://manvfat.com/cookie-policy/", text: "Cookie Policy", target: "_blank" },
];

export const playerSidebarLinks: Link[] = [
  { url: "/", text: "Home", end: true },
  { url: "/my-club", text: "My club", end: true },
  { url: "/food-and-nutrition", text: "Food and nutrition" },
  { url: "/fitness-and-football", text: "Fitness and football" },
  { url: "/useful-extras", text: "Useful extras" },
  { url: "/player-support", text: "Player support" },
];

export const staffSidebarLinks: Link[] = [
    { url: "/", text: "Home", end: true },
    { url: "/food-and-nutrition", text: "Food and nutrition" },
    { url: "/fitness-and-football", text: "Fitness and football" },
    { url: "/useful-extras", text: "Useful extras" },
    { url: "/player-support", text: "Player support" },
];

export const faqLinks: Link[] = [
  { url: "https://manvfatfootball.org/Home/FAQs", text: "FAQs", target: "_blank" },
  { url: "https://forms.office.com/r/2LP423LM6A", text: "Leave feedback", target: "_blank" },
];

export const profileNavLinks: Link[] = [{ url: "/log-out", text: "Log out" }];

export const facebookLink: Link = {
  url: "https://www.facebook.com/groups/manvfat",
  text: "Facebook",
  target: "_blank",
};
export const instagramLink: Link = { url: "https://www.instagram.com/manvfat", text: "Instagram", target: "_blank" };
export const twitterLink: Link = { url: "https://twitter.com/manvfat", text: "Twitter", target: "_blank" };
